import { Link } from 'react-router-dom';
import { ArrowRight, ClipboardList, Send, Settings2, MonitorCheck, Users } from 'lucide-react';

const STEPS = [
  { icon: ClipboardList, title: 'Define Your Requirements', desc: 'Choose the compute, storage, networking, security, backup, and management capabilities your workload requires.' },
  { icon: Send, title: 'Request Cloud Access', desc: 'Submit your workload requirements to DAAKYI.' },
  { icon: Settings2, title: 'DAAKYI Configures Your Environment', desc: 'DAAKYI reviews requirements and establishes the approved tenant, resources, networking, and security baseline.' },
  { icon: MonitorCheck, title: 'Access Your Cloud', desc: 'Authorized users receive access to the DAAKYI Cloud environment powered by Sangfor SCP.' },
  { icon: Users, title: 'Manage It or Let DAAKYI Manage It', desc: 'Manage authorized cloud resources yourself, or engage DAAKYI Managed Cloud for additional operational support.' }
];

export const HowItWorksSection = () => (
  <section className="py-16 lg:py-24 bg-[#F8FAFC]" data-testid="how-it-works-section">
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
      <div className="mb-12">
        <p className="text-[#A8631A] text-xs font-semibold uppercase tracking-widest mb-3">From Request to Running Workloads</p>
        <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-[#1A1240]">How DAAKYI Cloud works</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 mb-10">
        {STEPS.map(({ icon: Icon, title, desc }, i) => (
          <div key={title} className="bg-white border border-[#DCE4EE] rounded-xl p-5 relative" data-testid={`hiw-step-${i + 1}`}>
            <span className="absolute top-4 right-4 text-[#DCE4EE] font-black text-2xl">{i + 1}</span>
            <Icon className="w-5 h-5 text-[#A8631A] mb-3" strokeWidth={1.5} />
            <h3 className="text-[#1A1240] font-semibold text-sm mb-1.5 pr-6">{title}</h3>
            <p className="text-[#64748B] text-[13px] leading-relaxed">{desc}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Link to="/cloud-access" data-testid="hiw-request-access" className="btn-primary inline-flex items-center justify-center gap-2">
          Request Cloud Access <ArrowRight className="w-4 h-4" />
        </Link>
        <Link to="/platform" data-testid="hiw-platform-link" className="btn-glass inline-flex items-center justify-center gap-2">
          Learn About the Platform
        </Link>
      </div>
    </div>
  </section>
);

export default HowItWorksSection;
